<template>
  <div class="msg-management">
    <div class="left">
      <!-- <Tree :switchVal="searchParams.isDown" :showSwitch='true' @changeSwitch="changeSwitch" @nodeClick="nodeClick"></Tree> -->
      <Tree :showSwitch="false" title=" " @nodeClick="nodeClick"></Tree>
    </div>
    <div class="right">
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <!-- 充值记录 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'充值记录'"
      :visible.sync="dialogVisible1"
      width="70%"
      :before-close="handleClose1"
      custom-class="alert-table-box"
    >
      <TabelSearch
        :searchConfig="searchConfig1"
        :searchParams="searchParams1"
        @resetCallBack="resetCallBack1"
        @search="setSearchParams1"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading1"
        :templateData="tableTemplateData1"
        :tableConfig="tableConfig1"
        :pagination="pagination1"
      >
      </Table>
    </el-dialog>
    <!-- 发送统计 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'发送统计'"
      :visible.sync="dialogVisible2"
      width="70%"
      :before-close="handleClose2"
      custom-class="alert-table-box"
    >
      <TabelSearch
        :searchConfig="searchConfig2"
        :searchParams="searchParams2"
        @resetCallBack="resetCallBack2"
        @search="setSearchParams2"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading2"
        :templateData="tableTemplateData2"
        :tableConfig="tableConfig2"
      >
      </Table>
    </el-dialog>
    <!-- 发送记录 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'发送记录'"
      :visible.sync="dialogVisible3"
      width="70%"
      :before-close="handleClose3"
      custom-class="alert-table-box"
    >
      <TabelSearch
        :searchConfig="searchConfig3"
        :searchParams="searchParams3"
        @resetCallBack="resetCallBack3"
        @search="setSearchParams3"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading3"
        :templateData="tableTemplateData3"
        :tableConfig="tableConfig3"
        :pagination="pagination3"
      >
      </Table>
    </el-dialog>
    <!-- 充值弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'充值'"
      :visible.sync="dialogVisible4"
      width="50%"
      :before-close="handleClose4"
    >
      <editForm
        ref="editForm"
        :formConfig="formConfig"
        :ruleForm="ruleForm"
        :rules="rules"
        :buttonConfig="buttonConfig"
      ></editForm>
      <div class="pay-info" v-if="codeImg">
        <div class="money">
          <div>
            <span class="iconfont iconweixinzhifu"></span
            ><span>亿万用户的选择，更快更安全</span>
          </div>
          <div>
            支付<span style="font-size: 18px; margin: 0 10px; color: red">{{
              sysInfoList[ruleForm.level[0]].money
            }}</span
            >元
          </div>
        </div>
        <div class="code">
          <img :src="codeImg" alt="" />
        </div>
        <div class="code">请使用微信扫描二维码以完成支付</div>
        <!-- <div class="tips">
					<div class="tips-title">温馨提示:</div>
					<span>1.这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字</span>
					<span>2.这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字</span>
					<span>3.这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字</span>
					<span>4.这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字这里是说明文字文字</span>
				</div> -->
      </div>
    </el-dialog>

    <el-dialog
      width="300px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="sucDialog"
    >
      <div class="money-box">
        <i class="iconfont iconchenggong" style="color: #6bcc03"></i>
        <span class="result suc">充值成功</span>
        <!-- <span class="info">这里是一些信息说明</span> -->
        <div class="btn">
          <el-button @click="sucClose" type="primary">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="300px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="failDialog"
    >
      <div class="money-box">
        <i class="iconfont iconshibai" style="color: red"></i>
        <span class="result fail">充值失败</span>
        <!-- <span class="info">这里是一些信息说明</span> -->
        <div class="btn">
          <el-button @click="failClose" type="primary">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree.vue";
import Table from "../../../../components/table/table";
import TabelSearch from "../../../../components/tabel-search/tabel-search.vue";
import editForm from "../../../../components/edit-form/edit-form";
import { msgApi } from "../../../../api-path/msg-api.js";
import { districtApi } from "../../../../api-path/district-api.js";
const sysList = [
  { name: "套餐一(1万条)", value: 0, money: 1000, num: "10000" },
  { name: "套餐二(2万条)", value: 1, money: 1900, num: "20000" },
  { name: "套餐三(5万条)", value: 2, money: 4000, num: "50000" },
  { name: "套餐四(10万条)", value: 3, money: 7000, num: "1000000" },
];
export default {
  components: {
    Tree,
    Table,
    TabelSearch,
    editForm,
  },
  data() {
    return {
      searchParams: {
        isDown: false,
        areaId: "",
        page: 1,
        size: 15,
        checkSms: true,
      },
      isDown: false,
      areaId: "",
      tableConfig: {
        rows: [
          {
            label: "区域",
            prop: "name",
          },
          {
            label: "剩余短信",
            prop: "msgLimits",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "充值记录",
              fn: (value) => {
                this.dialogVisible1 = true;
                this.searchParams1.areaId = value.id;
                this.setSearchParams1();
              },
            },
            {
              label: "发送统计",
              fn: (value) => {
                this.dialogVisible2 = true;
                this.searchParams2.areaId = value.id;
                this.setSearchParams2();
              },
            },
            {
              label: "发送记录",
              fn: (value) => {
                this.dialogVisible3 = true;
                this.searchParams3.areaId = value.id;
                this.setSearchParams3();
              },
            },
          ],
        },
      },
      tableLoading: false,
      tabelButtons: [
        {
          type: "add",
          title: "充值",
          fn: () => {
            this.codeImg = "";
            this.outTradeNo = "";
            this.ruleForm = {
              areaId: "",
              level: [0],
              areaName: "",
            };
            this.dialogVisible4 = true;
          },
        },
      ],
      tableTemplateData: [],
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      // 充值记录
      dialogVisible1: false,
      searchConfig1: {
        items: [
          {
            key: "time",
            valueType: "daterange",
          },
          {
            key: "status",
            valueType: "select",
            placeholder: "全部状态",
            option: {
              label: "name",
              value: "value",
            },
            data: [
              {
                name: "未支付",
                value: "NOTPAY",
              },
              {
                name: "支付成功",
                value: "SUCCESS",
              },
              {
                name: "已关闭",
                value: "CLOSED",
              },
            ],
          },
          {
            key: "userName",
            valueType: "text",
            placeholder: "请输入用户名",
          },
          {
            key: "phone",
            valueType: "text",
            placeholder: "请输入手机号",
          },
        ],
      },
      searchParams1: {
        startTime: "",
        endTime: "",
        status: "",
        userName: "",
        phone: "",
        page: 1,
        size: 15,
      },
      tableLoading1: false,
      tableTemplateData1: [],
      tableConfig1: {
        rows: [
          {
            label: "充值条数",
            prop: "number",
          },
          {
            label: "充值金额",
            prop: "money",
          },
          {
            label: "充值用户",
            prop: "userName",
          },
          {
            label: "电话号码",
            prop: "phone",
          },
          {
            label: "订单状态",
            prop: "status",
          },
          {
            label: "下单时间",
            prop: "createGmt",
          },
          {
            label: "支付时间",
            prop: "payGmt",
          },
        ],
      },
      pagination1: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange1,
        pageChange: this.pageChange1,
      },
      //发送统计
      dialogVisible2: false,
      searchConfig2: {
        items: [
          {
            key: "month",
            valueType: "month",
          },
        ],
      },
      searchParams2: {
        month: "",
        areaId: "",
      },
      tableLoading2: false,
      tableTemplateData2: [],
      tableConfig2: {
        height: 400,
        rows: [
          {
            label: "发送时间",
            prop: "month",
          },
          {
            label: "发送总数（条）",
            prop: "num",
          },
        ],
      },
      //发送记录
      dialogVisible3: false,
      searchConfig3: {
        items: [
          {
            key: "startTime",
            valueType: "date",
          },
          {
            key: "phone",
            valueType: "text",
            placeholder: "请输入手机号",
          },
        ],
      },
      searchParams3: {
        startTime: "",
        phone: "",
        page: 1,
        size: 15,
      },
      tableLoading3: false,
      tableTemplateData3: [],
      tableConfig3: {
        rows: [
          {
            label: "所属区域",
            prop: "areaName",
          },
          {
            label: "发送号码",
            prop: "phone",
          },
          {
            label: "短信内容",
            prop: "content",
            width: "150px",
            type: "popover",
          },
          {
            label: "发送条数",
            prop: "num",
          },
          {
            label: "发送状态",
            prop: "status",
          },
          {
            label: "发送时间",
            prop: "createGmt",
          },
        ],
      },
      pagination3: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange3,
        pageChange: this.pageChange3,
      },
      //充值弹窗
      dialogVisible4: false,
      formConfig: {
        ref: "msgform",
        disabled: false,
        items: [
          [
            {
              valueType: "tree-selected", // 类型
              label: "充值区域",
              key: "areaName", // 数据名称
              prop: "areaName", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              maxlength: 50,
              disabled: false,
              placeholder: "请选择区域", // 提示信息
              fn: (data) => {
                //选择的值
                this.ruleForm.areaName = data.name;
                this.ruleForm.areaId = data.id;
              },
            },
          ],
          [
            {
              valueType: "fixedLabel", // 类型
              label: "套餐选择",
              key: "level", // 数据名称
              prop: "level", // 验证规则
              labelWidth: "140px", // label 宽度
              itemWidth: "100%",
              data: sysList,
              options: {
                label: "name",
                value: "value",
              },
            },
          ],
        ],
      },
      ruleForm: {
        areaId: "",
        level: [0],
        areaName: "",
      },
      sysInfoList: sysList,
      rules: {
        areaName: [
          {
            required: true,
            message: "请选择充值区域",
            trigger: "blur",
          },
        ],
        level: [
          {
            required: true,
            message: "请选择充值套餐",
            trigger: "blur",
          },
        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save",
            title: "生成订单",
            fn: (data) => {
              clearInterval(this.timer);
              let requestData = JSON.parse(JSON.stringify(data));
              let params = {
                areaId: requestData.areaId,
                money: this.sysInfoList[requestData.level[0]].money,
                number: this.sysInfoList[requestData.level[0]].num,
              };
              this.$http.post(msgApi.save, params).then((res) => {
                if (res.status === 200) {
                  this.codeImg = res.result.codeImage;
                  this.outTradeNo = res.result.outTradeNo;
                  this.timer = setInterval(() => {
                    this.checkPay();
                  }, 10000);
                }
              });
            },
          },
        ],
      },
      sucDialog: false,
      failDialog: false,
      //订单相关数据
      codeImg: "",
      outTradeNo: "",
      timer: "",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    changeSwitch(e) {
      this.isDown = e;
      this.searchParams.isDown = e;
      this.search();
    },
    nodeClick(node) {
      this.areaId = node.id;
      this.searchParams.areaId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.searchParams.size = this.pagination.size = 15;
      this.search();
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.search();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.search();
    },
    search() {
      this.$http
        .get(districtApi.queryListByPage, {
          params: this.searchParams,
        })
        .then((res) => {
          if (res.status === 200) {
            let result = res.result.pageList;
            this.tableTemplateData = result;
            this.pagination.total = res.result.total;
          }
        });
    },
    /***************充值记录*******************/
    handleClose1() {
      this.dialogVisible1 = false;
    },
    resetCallBack1() {
      (this.searchParams1.time = []),
        (this.searchParams1.status = ""),
        (this.searchParams1.userName = ""),
        (this.searchParams1.phone = ""),
        (this.searchParams1.page = this.pagination1.page = 1);
      this.searchParams1.size = this.pagination1.size = 15;
      this.setSearchParams1();
    },
    // 每页显示条数
    sizeChange1(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams1();
    },
    // 当前页
    pageChange1(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.setSearchParams1();
    },
    setSearchParams1() {
      let params = JSON.parse(JSON.stringify(this.searchParams1));
      if (params.time) {
        params.startTime = params.time[0];
        params.endTime = params.time[1];
        delete params.time;
      }
      //请求数据
      this.$http.get(msgApi.pageList, { params }).then((res) => {
        if (res.status == 200) {
          this.tableTemplateData1 = res.result.pageList;
          this.pagination1.total = res.result.total;
        }
      });
    },
    /***************发送统计*******************/
    handleClose2() {
      this.dialogVisible2 = false;
    },
    resetCallBack2() {
      this.searchParams2.month = "";
      this.setSearchParams2();
    },
    setSearchParams2() {
      //请求数据
      this.$http.get(msgApi.month, { params: this.searchParams2 }).then((res) => {
        if (res.status == 200) {
          this.tableTemplateData2 = res.result;
        }
      });
    },
    /***************发送记录*******************/
    handleClose3() {
      this.dialogVisible3 = false;
    },
    resetCallBack3() {
      (this.searchParams3.startTime = ""),
        (this.searchParams3.phone = ""),
        (this.searchParams3.page = this.pagination3.page = 1);
      this.searchParams3.size = this.pagination3.size = 15;
      this.setSearchParams3();
    },
    // 每页显示条数
    sizeChange3(size) {
      this.pagination3.size = size;
      this.searchParams3.size = size;
      this.setSearchParams3();
    },
    // 当前页
    pageChange3(page) {
      this.pagination3.page = page;
      this.searchParams3.page = page;
      this.setSearchParams3();
    },
    setSearchParams3() {
      //请求数据
      this.$http.get(msgApi.content, { params: this.searchParams3 }).then((res) => {
        if (res.status == 200) {
          this.tableTemplateData3 = res.result.pageList;
          this.pagination3.total = res.result.total;
        }
      });
    },
    /***************充值弹窗****************/
    //检测是否支付成功
    checkPay() {
      this.$http.get(msgApi.queryWxOrder + "/" + this.outTradeNo).then((res) => {
        if (res.status == 200) {
          if (res.result.trade_state === "NOTPAY") {
          } else if (res.result.trade_state === "SUCCESS") {
            clearInterval(this.timer);
            this.dialogVisible4 = false;
            this.sucDialog = true;
            this.setSearchParams1();
          } else {
            clearInterval(this.timer);
            this.dialogVisible4 = false;
            this.failDialog = true;
            this.setSearchParams1();
          }
        }
      });
    },
    handleClose4() {
      clearInterval(this.timer);
      this.dialogVisible4 = false;
      this.setSearchParams1();
      // this.$confirm('支付已完成吗？', '提示', {
      //     confirmButtonText: '已支付',
      //     cancelButtonText: '未支付',
      //     // type: type
      // }).then(() => {
      //     this.sucDialog=true;
      // }).catch(() => {
      //    this.failDialog=true;
      // });
    },
    sucClose() {
      this.dialogVisible4 = false;
      this.sucDialog = false;
    },
    failClose() {
      this.dialogVisible4 = false;
      this.failDialog = false;
    },
  },
};
</script>

<style scoped lang="less">
.msg-management {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;

    .plug-tree {
    }
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .pay-info {
    margin: 0 60px;
    .money {
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      .iconweixinzhifu {
        color: #6bcc03;
        margin-right: 10px;
      }
    }
    .code {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .tips {
      padding-top: 20px;
      margin-top: 10px;
      border-top: 1px solid #ddd;
      .tips-title {
        margin-bottom: 10px;
      }
      span {
        display: inline-block;
        font-size: 12px;
      }
    }
  }

  .money-box {
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .iconfont {
      font-size: 30px;
    }
    .result {
      font-size: 18px;
      margin: 10px 0;
    }
    .btn {
      margin-top: 10px;
    }
  }
}
</style>
